import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

Vue.filter('dateFormat', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  if(!dataStr){
    return '';
  }
  return moment(dataStr).format(pattern)
})

Vue.filter('shortDate', function (dataStr) {
  if(!dataStr){
    return '';
  }
  return moment(dataStr).format('YYYY-MM-DD')
})

Vue.filter('shortDate2', function (dataStr) {
  if(!dataStr){
    return '';
  }
  return moment(dataStr).format('MM-DD')
})

Vue.directive('focus', {
  inserted: function(el, binding) {
      //console.log(el)
      el.focus()
  }
})